import {
  LayoutDashboard,
  BarChart3,
  Database,
  Settings,
  PlayCircle,
  Users,
  CreditCard,
  Receipt,
  Bell,
  Image,
  Languages,
  Layers,
  UserCheck,
  FileText,
  Shield,
  RotateCcw,
  Package,
  Coins,
  ChevronDown,
  ChevronRight,
} from "lucide-react";

export const SidebarData = (darkMode) => {
  return [
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: <LayoutDashboard size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
    },
    {
      title: "Analytics",
      path: "/analytics",
      icon: <BarChart3 size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
    },
    {
      title: "Master",
      path: "/master/",
      icon: <Database size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
      subNav: [
        {
          title: "Language",
          path: "/master/language",
          icon: <Languages size={16} />,
          access: "true",
        },
        {
          title: "Genre",
          path: "/master/genre",
          icon: <Layers size={16} />,
          access: "true",
        },
        {
          title: "Cast",
          path: "/master/cast",
          icon: <UserCheck size={16} />,
          access: "true",
        },
      ],
    },
    {
      title: "Settings",
      path: "/setting/",
      icon: <Settings size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
      subNav: [
        {
          title: "About Us",
          path: "/setting/aboutus",
          icon: <FileText size={16} />,
          access: "true",
        },
        {
          title: "Privacy Policy",
          path: "/setting/privacypolicy",
          icon: <Shield size={16} />,
          access: "true",
        },
        {
          title: "Terms & Conditions",
          path: "/setting/termsconditions",
          icon: <FileText size={16} />,
          access: "true",
        },
        {
          title: "Refund Policy",
          path: "/setting/refundpolicy",
          icon: <RotateCcw size={16} />,
          access: "true",
        },
      ],
    },
    {
      title: "Series",
      path: "/series",
      icon: <PlayCircle size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
    },
    {
      title: "Customer",
      path: "/customer",
      icon: <Users size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
    },
    {
      title: "Subscription",
      path: "/subscription/",
      icon: <CreditCard size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
      subNav: [
        {
          title: "Plan",
          path: "/subscription/plan",
          icon: <Package size={16} />,
          access: "true",
        },
        {
          title: "Coin Plan",
          path: "/subscription/coin-plan",
          icon: <Coins size={16} />,
          access: "true",
        },
      ],
    },
    {
      title: "Transaction",
      path: "/transaction",
      icon: <Receipt size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
    },
    {
      title: "Notification",
      path: "/notification",
      icon: <Bell size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
    },
    {
      title: "Slider Banner",
      path: "/slider-banner/",
      icon: <Image size={20} />,
      iconClosed: <ChevronRight size={16} />,
      iconOpened: ChevronDown,
      access: "true",
      subNav: [
        {
          title: "Banner",
          path: "/slider/banner",
          icon: <Image size={16} />,
          access: "true",
        },
        {
          title: "Login Banner",
          path: "/slider/login",
          icon: <Image size={16} />,
          access: "true",
        },
      ],
    },
  ];
};
